import fetch from 'isomorphic-fetch';
import * as actions from '../productSearch/productSearchActionsConstants';
import {STATION_SEARCH_REQUEST} from '../stationSearch/stationSearchActionsConstants';
import * as steps from '../productSearch/productSearchStepConstants';

const trackProductSearch = (state, event_type) => {
  let currentState = state,
    data = {
      event_type: event_type,
      depart_date: currentState.productSearch.travel_date_selection,
      depart_time: currentState.productSearch.travel_time_selection,
      origin_query: (currentState.productSearch.step === steps.ORIGIN_SEARCH) ? currentState.stationSearch.query : null,
      destination_query: (currentState.productSearch.step === steps.DESTINATION_SEARCH) ? currentState.stationSearch.query : null,
      origin_codes_selection: currentState.productSearch.origin_selections.map((s) => s.code),
      destination_codes_selection: currentState.productSearch.destination_selections.map((s) => s.code),
      passengers: currentState.productSearch.passenger_quantity
    };
  return fetch(
      '/flight_search_queries/track', {
        method: 'POST',
        body: JSON.stringify({ data: data }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': window.csrf,
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin'
      }
    )
}

const trackProductSearchOriginSearched = _.debounce(trackProductSearch, 3000);
const trackProductSearchDestinationSearched = _.debounce(trackProductSearch, 3000);

const searchQueryTracker = store => next => action => {
  let result = next(action);
  let state = store.getState();
  switch (action.type) {
  case STATION_SEARCH_REQUEST:
    if (state.productSearch.step === steps.ORIGIN_SEARCH) {
      trackProductSearchOriginSearched(state, 'origin_searched')
    } else if (state.productSearch.step === steps.DESTINATION_SEARCH) {
      trackProductSearchDestinationSearched(state, 'destination_searched');
    }
    break;
  case actions.ORIGIN_STATIONS_SELECTED:
    trackProductSearch(state, 'origin_selected');
    break;
  case actions.DESTINATION_STATIONS_SELECTED:
    trackProductSearch(state, 'destination_selected');
    break;
  case actions.SWAP_STATION_VALUES:
    trackProductSearch(state, 'selected_stations_swapped');
    break;
  case actions.PASSENGER_QUANTITY_SELECTED:
    trackProductSearch(state, 'passenger_quantity_selected');
    break;
  case actions.TRAVEL_DATE_SELECTED:
    trackProductSearch(state, 'depart_date_selected');
    break;
  case actions.TRAVEL_TIME_SELECTED:
    trackProductSearch(state, 'depart_time_selected');
    break;
  }
  return result;
}

export default searchQueryTracker;
